import { z } from 'zod'

const ZTextToSpeechContent = z.object({
  say: z.string(),
  voice: z.string(),
})

export default ZTextToSpeechContent
